<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">

      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>

      <form-group label="Api key">
        <input class="form-input" v-model="config.auth.apiKey">
      </form-group>
    </div>

    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <form-group label="URL personalizada">
          <input class="form-input" type="text" v-model="config.quotation.customUrl">
        </form-group>

        <form-group label="CEP de origem">
          <input class="form-input" type="text" v-model="config.quotation.zipCodeOrigin">
        </form-group>

        <form-group label="Unidade de peso">
          <select v-model="config.quotation.unitWeight" class="form-select">
            <option v-for="unitWeight in unitWeights" :key="unitWeight" :value="unitWeight">{{ $t(`unitWeight.${unitWeight}.label`) }}</option>
          </select>
        </form-group>

        <form-group label="Dimensões">
          <select v-model="config.quotation.dimension" class="form-select">
            <option v-for="dimension in dimensions" :key="dimension" :value="dimension">{{ $t(`dimensions.${dimension}.label`) }}</option>
          </select>
        </form-group>

        <form-group label="Agrupar produtos">
          <select v-model="config.quotation.canGroup" class="form-select">
            <option value="true">{{ $t(`true.label`) }}</option>
            <option value="false">{{ $t(`false.label`) }}</option>
          </select>
        </form-group>
      </div>
    </panel>
  </module-configuration>
</template>

<script>
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'

  export default {
    provide: {
      moduleDI: {
        type: 'shipment',
        identifier: 'intelipost'
      }
    },
    data: () => ({
      errors: [],
      type: 'shipment',
      identifier: 'intelipost',
      config: {
        auth: {
          environment: 'sandbox',
          apiKey: null
        },
        quotation: {
          zipCodeOrigin: null,
          unitWeight: 'kg',
          dimension: 'cm',
          canGroup: false
        }
      },
      unitWeights: [
        'kg',
        'g'
      ],
      dimensions: [
        'mm',
        'cm',
        'm'
      ]
    }),
    components: {
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Intelipost.vue?1a087119